const C_TRUST_ENTITY = {
  BAN_RESERVA: {
    label: "BanReseservas",
    value: 1,
    id: 1,
    name: "BanReseservas"
  },
  POPULAR: {
    label: "Popular",
    value: 2,
    id: 2,
    name: "Popular"
  },
  LA_NACIONAL: {
    label: "Asociación La Nacional de Ahorros y Préstamos - ALNAP",
    value: 3,
    id: 3,
    name: "Asociación La Nacional de Ahorros y Préstamos - ALNAP"
  },
  APAP: {
    label: "Asociación Popular de Ahorros y Préstamos - APAP",
    value: 4,
    id: 4,
    name: "Asociación Popular de Ahorros y Préstamos - APAP"
  },
  DAF: {
    label: "DAF",
    value: 5,
    id: 5,
    name: "DAF"
  },
  UNIVERSAL: {
    label: "Universal",
    value: 6,
    id: 6,
    name: "Universal"
  },
  FIDUCORP: {
    label: "FIDUCORP",
    value: 7,
    id: 7,
    name: "FIDUCORP"
  }
};

export const A_TRUST_ENTITY = [
  C_TRUST_ENTITY.LA_NACIONAL,
  C_TRUST_ENTITY.APAP,
  C_TRUST_ENTITY.BAN_RESERVA,
  C_TRUST_ENTITY.DAF,
  C_TRUST_ENTITY.FIDUCORP,
  C_TRUST_ENTITY.POPULAR,
  C_TRUST_ENTITY.UNIVERSAL
];

export const O_TRUST_ENTITY = {
  [C_TRUST_ENTITY.POPULAR.id]: C_TRUST_ENTITY.POPULAR,
  [C_TRUST_ENTITY.BAN_RESERVA.id]: C_TRUST_ENTITY.BAN_RESERVA,
  [C_TRUST_ENTITY.LA_NACIONAL.id]: C_TRUST_ENTITY.LA_NACIONAL,
  [C_TRUST_ENTITY.APAP.id]: C_TRUST_ENTITY.APAP,
  [C_TRUST_ENTITY.DAF.id]: C_TRUST_ENTITY.DAF,
  [C_TRUST_ENTITY.UNIVERSAL.id]: C_TRUST_ENTITY.UNIVERSAL,
  [C_TRUST_ENTITY.FIDUCORP.id]: C_TRUST_ENTITY.FIDUCORP
};

export default C_TRUST_ENTITY;
